export default __webpack_public_path__ + "static/media/lightbox-mono.2f30d6c2.svg";